import { render, staticRenderFns } from "./PayoutsMiniCard.vue?vue&type=template&id=5898848a&"
import script from "./PayoutsMiniCard.vue?vue&type=script&lang=js&"
export * from "./PayoutsMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports